import Typography from '@mui/material/Typography'
import type React from 'react'

import type { CustomLinkComponent, SidebarMenuItem } from '../Sidebar/types'
import { getLinkComponent, getLinkProps } from '../Sidebar/utils'
import * as S from './styles'

export interface MenuItemBtnProps {
  menuItem: SidebarMenuItem
  onClick: (menuItem: SidebarMenuItem) => void
  linkComponent?: CustomLinkComponent
}

export const MenuItemBtn: React.FC<MenuItemBtnProps> = ({ menuItem, onClick, linkComponent }) => {
  const linkProps = getLinkProps(menuItem)

  return (
    <S.StyledLinkComponent
      as={menuItem.url ? getLinkComponent(linkComponent) : 'button'}
      data-test="menu-item-label"
      data-test-id={menuItem.id}
      onClick={() => onClick(menuItem)}
      {...linkProps}
    >
      {menuItem.icon}
      <Typography component="span" aria-label={menuItem.ariaLabel} sx={{ fontWeight: '500' }}>
        {menuItem.label}
      </Typography>
      {menuItem.badge}
    </S.StyledLinkComponent>
  )
}

MenuItemBtn.displayName = 'MenuItemBtn'
